import React from 'react';
import { ThunderboltOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import { TRANSACTION_TYPE } from '../treasury.constants';
import styles from './styles/pills.module.scss';

const ICONS = {
    [TRANSACTION_TYPE.INSTANT]: <ThunderboltOutlined />,
    [TRANSACTION_TYPE.STANDARD]: <ClockCircleOutlined />,
};

const LABELS = {
    [TRANSACTION_TYPE.INSTANT]: 'Instant',
    [TRANSACTION_TYPE.STANDARD]: 'Standard',
};

const TONES = {
    [TRANSACTION_TYPE.INSTANT]: styles.typeInstant,
    [TRANSACTION_TYPE.STANDARD]: styles.typeStandard,
};

/**
 * Type indicator rendered inside the "Type" column of the transactions
 * table. Matches the Figma reference (node 5679:6433): inline icon +
 * label pair, no background pill or border. Shares structure with
 * `TransactionStatusPill` — only the tone colour differs.
 */
function TransactionTypePill({ type }) {
    const safeType = type || TRANSACTION_TYPE.STANDARD;
    const tone = TONES[safeType] || TONES[TRANSACTION_TYPE.STANDARD];

    return (
        <span className={`${styles.pill} ${tone}`}>
            <span className={styles.icon} aria-hidden="true">
                {ICONS[safeType]}
            </span>
            <Text as="span" size="xs" className={styles.label}>
                {LABELS[safeType]}
            </Text>
        </span>
    );
}

export default TransactionTypePill;
